import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import 'react-toastify/dist/ReactToastify.css';
import * as appointmentActions from '../../actions/appointmentActions';
// import { browserHistory } from 'react-router';
import Moment from 'react-moment';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {
	Modal,
} from 'react-bootstrap';
import moment from 'moment';
// import momentzone from 'moment-timezone'
class NoShowAppointment extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			forgotModalOpen: false,
			noshowflag: '',
			noShowappointmentList: this.props.noShowappointmentList,
		};
		this.onChange = this.onChange.bind(this);
		this.appointmentRemindLater = this.appointmentRemindLater.bind(this);
	}

	onChange(e) {
		var value = e.target.value;
		var msg = e.target.value;
		confirmAlert({
			title: 'Confirm',
			message: 'Are you sure you wish to mark appointment as No show by ' + msg + ' ?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						this.setState({
							'noshowflag': value
						}, function () {
						})
						if (value == 'patient')
							var appointmentStatus = '4'
						else
							var appointmentStatus = '3'
						var appointmentObj = {
							appointmentId: this.state.noShowappointmentList[0]._id,
							appointmentStatus: appointmentStatus,
							specialistId: this.state.noShowappointmentList[0].doctorId
						}
						this.props.actions.updateAppointmentShowDetails(appointmentObj)
						// this.props.closeNoShowAppointmentModal();
						this.props.nextNohowReminder();
						// window.location.reload();
						// browserHistory.push('/specialist/my-appointment');

					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		})

	}
	appointmentRemindLater() {
		localStorage.setItem('noShowRemind', false);
		// this.props.closeNoShowAppointmentModal();
		this.props.nextNohowReminder();
	}
	render() {
		let userlocation = moment(new Date()).tz(moment.tz.guess()).format('z');

		return (
			<Modal show={this.props.openNoAppointmentShowModal} size="modal-sm" onHide={this.props.closeNoShowAppointmentModal}>
				<Modal.Header>
					{/* <ModalClose onClick={this.props.closeNoShowAppointmentModal} /> */}

				</Modal.Header>
				<Modal.Body className="myAppPopUp">
					<div className="myAppPopUp">
						<p className="popUpT">Please mark the below appointment as</p>
						<div className="radio radio-primary">
							<input type="radio" name="noshow" id="noshow1" onChange={this.onChange} value="patient" checked={this.state.noshowflag == 'patient'} />
							<label htmlFor="noshow1"> No Show By Patient</label>
						</div>
						<div className="radio radio-primary">
							<input type="radio" name="noshow" id="noshow2" onChange={this.onChange} value="specialist" checked={this.state.noshowflag == 'specialist'} />
							<label htmlFor="noshow2"> No Show By Specialist</label>
						</div>
						<hr />
						<div className="textData text-capitalize">
							<label className="text-capitalize">Patient Name : {this.state.noShowappointmentList[0].patientInfo.userName} </label>
						</div>
						<div className="textData">
							<label >Appointment Date : <Moment format="DD-MM-YYYY">{this.state.noShowappointmentList[0].appointmentDate}</Moment></label>
						</div>
						<div className="textData">
							<label >Appointment Time : {this.state.noShowappointmentList[0].appointmentDate ? moment(this.state.noShowappointmentList[0].appointmentDate).format('hh:mm A') + " " + userlocation: ''}</label>
						</div>
						<div className="col-sm-6 remindmelater" >
							<button type="button" className="btn btn-block btn-warning" onClick={this.appointmentRemindLater}>
								<span>Remind me later</span>
							</button>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >
		);
	}
}
function mapStateToProps(state, ownProps) {
	return {
		signin: state.signin
	};
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(NoShowAppointment);
